// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root, :host {
    --default-header-bg: var(--whiz-header-bg, black);
    --default-header-text: var(--whiz-header-text, white);
    --default-bg-chat: var(--whiz-bg-chat, white);
    --default-text-primary: var(--whiz-text-primary, white);
    --default-bg-primary: var(--whiz-bg-primary, #333);
    --default-text-secondary: var(--whiz-text-secondary, #333);
    --default-bg-secondary: var(--whiz-bg-secondary, #f5f5f5);
    --default-button-active: var(--whiz-button-active, #0F78E1);
    --default-button-divider: var(--whiz-button-divider, #DBDBDB);
    --default-bg-button: var(--whiz-bg-button, #D9D9D9);
    --default-quick-reply-border: var(--whiz-quick-reply-border, #999);

    --mui-palette-primary-main: var(--whiz-text-primary, white);
    --mui-palette-primary-light: var(--whiz-text-primary, white);
    --mui-palette-primary-dark: var(--whiz-text-primary, white);
    --mui-palette-action-disabled: var(--whiz-bg-secondary, #f5f5f5);
    --mui-palette-text-disabled: var(--whiz-text-secondary, #333);
    --mui-palette-background-paper: var(--whiz-bg-primary, #333);
    --mui-palette-secondary-main: var(--whiz-text-secondary, #333);
}

ol, ul {
    padding-left: 16px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
